import { DismissablePromptType } from '@ms/yammer-data/dist/state/types';
import {
  useLoadDismissablePromptsByType,
  useShouldStartDismissablePrompt,
} from '@ms/yammer-hooks/dist/dismissablePromptsByType';
import React, { ReactNode, Suspense } from 'react';

import LoadableMaintenanceOutageBanner from './LoadableMaintenanceOutageBanner';
import LoadableOutageBanner from './LoadableOutageBanner';
import LoadableScheduledMaintenanceOutageBanner from './LoadableScheduledMaintenanceOutageBanner';

const outagePromptTypes: DismissablePromptType[] = [
  DismissablePromptType.LIVE_SITE_ISSUE,
  DismissablePromptType.MAINTENANCE_OUTAGE,
  DismissablePromptType.MAINTENANCE_OUTAGE_SCHEDULED,
];
type UseOutageBanner = () => ReactNode;
export const useOutageBanner: UseOutageBanner = () => {
  useLoadDismissablePromptsByType(outagePromptTypes);

  const shouldShowLiveSiteBanner = useShouldStartDismissablePrompt(DismissablePromptType.LIVE_SITE_ISSUE);
  const shouldShowMaintenanceBanner = useShouldStartDismissablePrompt(DismissablePromptType.MAINTENANCE_OUTAGE);
  const shouldShowScheduledMaintenanceBanner = useShouldStartDismissablePrompt(
    DismissablePromptType.MAINTENANCE_OUTAGE_SCHEDULED
  );

  if (shouldShowLiveSiteBanner) {
    return (
      <Suspense fallback={null}>
        <LoadableOutageBanner />
      </Suspense>
    );
  }

  if (shouldShowMaintenanceBanner) {
    return (
      <Suspense fallback={null}>
        <LoadableMaintenanceOutageBanner />
      </Suspense>
    );
  }

  if (shouldShowScheduledMaintenanceBanner) {
    return (
      <Suspense fallback={null}>
        <LoadableScheduledMaintenanceOutageBanner />
      </Suspense>
    );
  }

  return null;
};
